module.exports = __webpack_public_path__ + "static/media/hack-oregon-logo.acf323a1.svg";